import React from "react"
import styled from "@emotion/styled"
import { Container, Flex, Box } from "theme-ui"
import SignUpForm from "components/Homepage/signupForm"

const Wrapper = styled.div`
    position: relative;
    background-color: #eae8eb;

    & .learn-box {
        margin: 2rem 0.5rem;
        align-items: center;
        justify-content: center;

        & h2 {
            color: ${(props) => props.theme.colors.dark_grey_1};
        }

        & input {
            border-radius: 2rem;
            border: none;
            color: ${(props) => props.theme.colors.dark_grey_2};
            background-color: ${(props) => props.theme.colors.background};
            padding-left: 3rem;
            padding-right: 3rem;
            text-align: center;
        }
        & button {
            font-weight: normal;
            border-radius: 2rem;
            background-color: ${(props) => props.theme.colors.light_blue_1};
            color: ${(props) => props.theme.colors.background};
            margin-left: 1rem;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            margin: 1rem 0.5rem;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[2]}) {
            & input,
            button {
                padding-left: 1rem;
                padding-right: 1rem;
                font-size: 14px;
            }
        }
    }
    & .learn-box-flex {
        margin-left: auto;
    }
    & h2 {
        margin: 0;
    }
    & p {
        margin-top: 0;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & .learn-wrapper {
            flex-direction: column;
            justify-content: center;
            text-align: center;
        }
        & .learn-box-flex {
            margin-left: 0.5rem;
            justify-content: center;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        font-size: 14px;
        & h2 {
            font-size: 20px;
        }
    }
`

function LearnMore({ data }) {
    return (
        <Wrapper>
            <Container>
                <Flex className="learn-wrapper" sx={{ justifyContent: "left" }}>
                    <Box className="learn-box">
                        <h2>Learn more about us!</h2>
                        <p>
                            Join our mailing list and subscribe our newsletter
                            today.
                        </p>
                    </Box>
                    <Flex className="learn-box learn-box-flex">
                        <SignUpForm />
                    </Flex>
                </Flex>
            </Container>
        </Wrapper>
    )
}

export default LearnMore
